import React from 'react'
import './SearchInputField.scss'

const SearchInputField = ({
  value,
  setValue,
  label,
  hint = '',
  placeholder = '',
  enableAutofocus = true,
  enableAutocomplete = false,
  icon = null,
  forceStacked = false,
}) => {
  return (
    <label
      className={`SearchInputField ${forceStacked ? 'force-stacked' : ''}`}
    >
      {icon && <img src={icon} alt="" />}

      <div className="label-and-input-container">
        <div className="title">{label}</div>
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          autoComplete={enableAutocomplete ? 'on' : 'off'}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={enableAutofocus}
        />
        {hint && <div className="hint">{hint}</div>}
      </div>
    </label>
  )
}

export default SearchInputField
